import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import FullDate             from '../Fields/Dates/FullDate';
import YearMonth            from '../Fields/Dates/YearMonth';
import CalendarInput        from '../Fields/Dates/CalendarInput';
import Day                  from '../Fields/Dates/Day';
import DayOfWeek            from '../Fields/Dates/DayOfWeek';
import moment               from 'moment';

class DateInput extends Component {
    componentWillMount() {
        if (this.props.defaultValue) {
            this.setState({isValid: true});
            this.props.isValid(true);
        }
    }

    componentDidMount() {
        if (this.props.subType == 'year-month' && !window.uorn(this.props.defaultValue)) {
            this.childComponent.handleValidation();
        }
    }

    handleValidation(e) {
        return this.childComponent.handleValidation(e);
    }

    getCurrentValue() {
        switch(this.props.subType) {
            case 'year-month':
            case 'month-day':
                return this.childComponent.getCurrentValue();
            case 'calendar':
                if (this.childComponent.getCurrentValue() === null) {
                    return this.childComponent.getCurrentValue();
                } else {
                    return moment(this.childComponent.getCurrentValue());
                }
            case 'day':
            case 'day-of-the-week':
                return this.childComponent.getCurrentValue();

            default:
                return this.childComponent.getCurrentValue();
        }
    }

    render() {
        // default is 'full'
        switch(this.props.subType) {
            case 'year-month':
                return(
                    <YearMonth
                        fieldName={this.props.fieldName}
                        storageKey={this.props.storageKey}
                        question={this.props.question}
                        loadCachedValue={true}
                        dateType={this.props.subType}
                        totalMonths={0}
                        callbackFunction={this.props.callbackFunction}
                        source={this.props.source}
                        dataValidation={this.props.dataValidation}
                        isValid={this.props.isValid}
                        limitMonths={this.props.limitMonths}
                        ref={(instance) => {this.childComponent = instance;}}
                        defaultValue={this.props.defaultValue}
                        loadingKey={this.props.loadingKey}
                    />
                );
            case 'calendar':
                return(
                    <CalendarInput
                        fieldName={this.props.fieldName}
                        storageKey={this.props.storageKey}
                        question={this.props.question}
                        dataValidation={this.props.dataValidation}
                        callbackFunction={this.props.callbackFunction}
                        source={this.props.source}
                        isValid={this.props.isValid}
                        ref={(instance) => {this.childComponent = instance;}}
                        defaultValue={this.props.defaultValue}
                        loadingKey={this.props.loadingKey}
                    />
                );
            case 'month-day':
                return(
                    <question-row>Month + day date fields TBC</question-row>
                );
            case 'day':
                return(
                    <Day
                        fieldName={this.props.fieldName}
                        storageKey={this.props.storageKey}
                        question={this.props.question}
                        loadCachedValue={true}
                        dateType={this.props.subType}
                        dataValidation={this.props.dataValidation}
                        source={this.props.source}
                        isValid={this.props.isValid}
                        ref={(instance) => {this.childComponent = instance;}}
                        defaultValue={this.props.defaultValue}
                        loadingKey={this.props.loadingKey}
                    />
                );
            case 'day-of-the-week':
                return(
                <DayOfWeek
                        fieldName={this.props.fieldName}
                        storageKey={this.props.storageKey}
                        source={this.props.source}
                        isValid={this.props.isValid}
                        dataValidation={this.props.dataValidation}
                        ref={(instance) => {this.childComponent = instance;}}
                        defaultValue={this.props.defaultValue}
                        loadingKey={this.props.loadingKey}
                    />
                );
            default:
                return(
                    <FullDate
                        fieldName={this.props.fieldName}
                        storageKey={this.props.storageKey}
                        question={this.props.question}
                        loadCachedValue={true}
                        dateType={this.props.subType}
                        dataValidation={this.props.dataValidation}
                        source={this.props.source}
                        isValid={this.props.isValid}
                        ref={(instance) => {this.childComponent = instance;}}
                        defaultValue={this.props.defaultValue}
                        loadingKey={this.props.loadingKey}
                    />
                );
        }
    }
}

DateInput.propTypes = {
    subType: PropTypes.oneOf(['day-of-the-week', 'full', 'start-date', 'end-date', 'year-month', 'calendar', 'dob', 'month-day', 'day']).isRequired,
    fieldName:          PropTypes.string.isRequired,
    storageKey:         PropTypes.string,
    question:           PropTypes.string.isRequired,
    callbackFunction:   PropTypes.func,
    dataValidation:     PropTypes.string,
    source:             PropTypes.string,
    loadingKey:         PropTypes.string,
    defaultValue:       PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    limitMonths:        PropTypes.bool,
    isValid:            PropTypes.func,
};

DateInput.defaultProps = {
    type: 'full',
    defaultValue: null,
};

export default DateInput;


// WEBPACK FOOTER //
// ./src/components/Fields/DateInput.js